import * as React from 'react';
import styled from 'styled-components';
import { withRouter } from 'react-router-dom';

const PostPaymentContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100vh;
`;

const PostPaymentText = styled.span`
  font-weight: 400;
  line-height: 18px;
  font-size: 14px;
  text-align: center;
  margin-top: 12px;

  color: #00144d;

  span {
    font-weight: bold;
  }
`;

export const PostPaymentPage = () => {
  return (
    <PostPaymentContainer>
      <PostPaymentText>
        <span>
          Thanks for using us! Make sure to reach out to your host one week in advance to coordinate your pick-up. <a href="mailto:penn@storewith.co">Contact us</a> if you have any questions or changes to your order.
        </span>
        <br />
      </PostPaymentText>
    </PostPaymentContainer>
  );
};

export default withRouter(PostPaymentPage);



// WEBPACK FOOTER //
// ./src/pages/CustomerPayment/PostPaymentPage.tsx